import { t } from '@getaccept/lib-shared/src/helpers/translation.helper';

export class WidgetHelper {
  static getCountTitle(count: number) {
    return count === 1 ? t('document').toString() : t('documents').toString();
  }
}
